/**
 * @file Account related queries.
 */
import gql from 'graphql-tag';

import { UserDetails } from '../fragments/account';

export const MeQuery = gql`
  query meQuery {
    me {
      contact_phone
      roles
      email_verified
      active
      organization_name
      roles
      ...UserDetails
    }
  }
  ${UserDetails}
`;

export const MeWithRoles = gql`
  query meWithRoles {
    me {
      id
      roles
      ...UserDetails
    }
  }
  ${UserDetails}
`;
